<template>
  <div class="help padding_top">
    <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>，即可进入【医生工作室】，在顶部菜单栏中点击<span
        class="orange">【测试分析】</span>展示【待测评测试列表】
    </p>
    <img src="../../../assets/doctorImg/testAnalysis_a.png" alt="" height="301">
    <p><strong>第二步：</strong>在【待测评测试列表】中，点击右侧<span class="orange">【去分析】</span>按钮，跳转至【分析页面】
    </p>
    <img src="../../../assets/doctorImg/testAnalysis_b.png" alt="" height="342">
    <p><strong>第三步：</strong>在【分析页面】，查看用户测试详细选项及答案，并给出专业的评测结果，点击<span class="orange">【提交】</span>完成评测
    </p>
    <img src="../../../assets/doctorImg/testAnalysis_c.png" alt="" height="781">
  </div>

</template>

<script>
export default {
  name: "testAnalysis",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
